/**
 * Sign-in schemas — email first, then the password (or a code).
 * Messages are locale keys; the screen translates them.
 */

import { z } from 'zod';

/**
 * The password step of sign-in. Never the password RULE (`passwordSchema`):
 * an account made under an older rule must still sign in — Clerk says
 * whether the password is right.
 */
export const signInPasswordSchema = z.object({
  password: z.string().min(1, 'validation.password.required'),
});

export type SignInPasswordInput = z.infer<typeof signInPasswordSchema>;
